import Skeleton from "react-loading-skeleton";

export const ToggleButtonSkeleton = () => {
  return <Skeleton width={80} height={30} borderRadius={8} />;
};
